import React, { useEffect, useState } from 'react';

const LoadingScreen = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => onComplete(), 300);
          return 100;
        }
        return prev + 2;
      });
    }, 30);

    return () => clearInterval(timer);
  }, [onComplete]);

  return (
    <div className="fixed inset-0 z-[9999] bg-white flex items-center justify-center overflow-hidden">
      {/* Solar Panel Grid Background */}
      <div className="absolute inset-0 opacity-[0.65]">
        <div className="solar-grid-pattern w-full h-full"></div>
      </div>

      {/* Logo and Content */}
      <div className="relative z-10 text-center animate-fadeIn">
        <div className="mb-8 animate-scaleIn">
          <img
            src="https://customer-assets.emergentagent.com/job_ecoenergy/artifacts/6k0km9nu_shree%20durga%20solar.jpg"
            alt="Shri Durga Enterprises"
            className="w-48 h-48 mx-auto object-contain drop-shadow-2xl"
          />
        </div>
        
        <h1 className="text-3xl md:text-4xl font-bold text-[#004534] mb-4 animate-slideUp">
          Shri Durga Enterprises
        </h1>
        
        <p className="text-xl md:text-2xl text-[#0C6951] font-semibold mb-8 animate-slideUp delay-200">
          "Powering Tomorrow with Solar Energy Today"
        </p>

        {/* Progress Bar */}
        <div className="w-64 h-2 bg-gray-200 rounded-full mx-auto overflow-hidden animate-slideUp delay-400">
          <div
            className="h-full bg-gradient-to-r from-[#1e3a8a] to-[#22c55e] transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        <p className="text-sm text-[#807979] mt-4 animate-slideUp delay-600">
          Loading... {progress}%
        </p>
      </div>

      <style jsx>{`
        .solar-grid-pattern {
          background-image: 
            linear-gradient(90deg, rgba(30, 58, 138, 0.3) 1px, transparent 1px),
            linear-gradient(rgba(30, 58, 138, 0.3) 1px, transparent 1px);
          background-size: 80px 80px;
          animation: gridMove 20s linear infinite;
        }

        @keyframes gridMove {
          0% {
            transform: translate(0, 0);
          }
          100% {
            transform: translate(80px, 80px);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes scaleIn {
          from {
            transform: scale(0.5);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            transform: translateY(30px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.6s ease-out;
        }

        .animate-scaleIn {
          animation: scaleIn 0.8s ease-out;
        }

        .animate-slideUp {
          animation: slideUp 0.6s ease-out;
        }

        .delay-200 {
          animation-delay: 0.2s;
          opacity: 0;
          animation-fill-mode: forwards;
        }

        .delay-400 {
          animation-delay: 0.4s;
          opacity: 0;
          animation-fill-mode: forwards;
        }

        .delay-600 {
          animation-delay: 0.6s;
          opacity: 0;
          animation-fill-mode: forwards;
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
